import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { ref, reactive, onMounted, toRefs } from "vue";
import { useRoute } from "vue-router";
import { getCurrentInstance } from "vue";
import apis from "@/api";
import HelpUpload from '../HelpManual/HelpUpload.vue';
import { ElMessage } from "element-plus";
import { queryHelpManual, queryHelpManualPage, saveDownHelpManualRecord } from "@/api/modules/help";
import { srcType } from "@/utils/srcType";
export default {
  components: {
    HelpUpload
  },
  name: "HelpManual",
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const data = reactive({
      queryParam: {
        name: "",
        upUser: ""
      },
      title: "新增操作手册",
      visible: false,
      uploadVisible: false,
      uploadFiles: [],
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      tableData: []
    });
    onMounted(() => {
      loadData();
      console.log("初始化帮助手册查询开始------------");
    });
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };
    const loadData = () => {
      const params = {
        ...data.queryParam,
        // ...data.pagination
        total: data.pagination.totalSize,
        size: data.pagination.pageSize,
        current: data.pagination.pageNo
      };
      apis.queryHelpManualPage(params).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {});
    };
    const resetForm = formName => {
      proxy.$refs[formName].resetFields();
      loadData();
    };

    //显示弹窗
    const popupShow = (str, row) => {
      data.title = str.toString();
      data.uploadVisible = true;
    };

    //上传成功
    const handlerUploadSuccess = params => {
      let files = params.files;
      let name = params.fileNewName;
      if (files && files.length > 0) {
        let uploadFiles = [];
        files.forEach(f => {
          const item = {
            name: name,
            fileId: f.id,
            fileName: f.fileName,
            fileUrl: f.innerUrl,
            upTime: f.uploadTime,
            upUser: f.operator,
            fileType: f.fileType
          };
          uploadFiles.push(item);
        });
        data.uploadFiles = data.uploadFiles.concat(uploadFiles);
        //执行插入记录
        apis.saveHelpManual(data.uploadFiles[0]).then(res => {
          if (res.success) {
            data.uploadVisible = false;
            data.uploadFiles = [];
            ElMessage.success('文件上传及信息保存成功！');
            loadData();
          } else {
            ElMessage.error(res.msg);
          }
        }).catch(err => {
          ElMessage.error(err);
        }).finally(() => {});
      } else {
        ElMessage.error('请先上传帮助文档附件!');
      }
    };
    const downFile = row => {
      console.info("手册：", row);
      //先进行下载记录存储
      apis.saveDownHelpManualRecord({
        helpManualId: row.id
      }).then(res => {
        if (res.success) {
          console.info("手册下载：", row.id);
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        loadData();
        window.open(row.fileUrl);
      });
    };
    return {
      ...toRefs(data),
      proxy,
      HelpUpload,
      loadData,
      popupShow,
      handlerUploadSuccess,
      handleSizeChange,
      handleCurrentChange,
      downFile,
      resetForm,
      srcType
    };
  }
};